import {html, css, LitElement} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {property} from 'lit/decorators/property.js';
import {choose} from 'lit/directives/choose.js';
import {when} from 'lit/directives/when.js';
import {AttributeInterpreter, ConfigurationInterpreter} from '@viamedici-spc/configurator-ts';
import store from '../../store';
import {selectProductData, selectSpcConfiguration, selectSpcConfigurations} from '../../selectors';
import {getProductData} from '../../util/getProductData';
import {generalAttributeOptions} from '../../generalAttributeOptions';

// renders the appropriate attribute component based on configuration and data
@customElement('spc-attribute')
export class SpcAttribute extends connect(store)(LitElement) {

	@property({type: Object})
	attribute = {};

	@property({type: Boolean})
	hideDisabledValues = false

	@property({type: String})
	displayStyle = null;

	@property({type: String})
	instance = 'default';

	@property({type: Array})
	excludedValues = [];

	@property({type: Object})
	addon = null;

	constructor() {
		super();
		this.type = null;
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		const isDefaultInstance = this.instance === 'default' || this.instance === undefined || this.instance === null;
		const configuration = isDefaultInstance ? selectSpcConfiguration(state) : selectSpcConfigurations(state)[this.instance];
		//console.log(this.attributeId, this.instance, configuration, selectSpcConfigurations(state));
		if (configuration && this.attribute) {
			//const attribute = ConfigurationInterpreter.getChoiceAttribute(configuration, this.attributeId);
			if (this.attribute) {
				this.type = this.attribute.type;
			} else {
				this.type = 'Choice';
			}
		}
		if (!this.displayStyle ) {
			this.displayStyle = generalAttributeOptions[this.attribute.key]?.displayStyle || 'compactSelect';
		}
		if (!this.hideDisabledValues ) {
			this.hideDisabledValues = generalAttributeOptions[this.attribute.key]?.hideDisabledValues || false;
		}

		if (configuration && this.type === 'Choice') {
			//const attribute = ConfigurationInterpreter.getChoiceAttribute(configuration, this.attributeId);
			if (this.attribute) {
				//console.log('attribute', attribute);
				const values = AttributeInterpreter.getAllowedChoiceValues(this.attribute);
				if (values && values.length > 40) {
					// this.displayStyle = 'comboSelect';
				}
			}
		}
	}

	render() {
		return html`
			${choose(
				this.type,
				[
					['Choice', () =>
						html`${choose(this.displayStyle,
							[
								['colorSelect',
									() => html`
										<spc-choice-attribute-color instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
																	.hideDisabledValues=${this.hideDisabledValues}
																	.excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['comboSelect',
									() => html`
										<spc-choice-attribute-combo instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
																	.hideDisabledValues=${this.hideDisabledValues}
																	.excludedValues=${this.excludedValues}></spc-choice-attribute-combo>`
								],
								['listSelect',
									() => html`
										<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
															  .hideDisabledValues=${this.hideDisabledValues}
															  .excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['reducedSelect',
									() => html`
										<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
															  .hideDisabledValues=${true} .excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['compactSelect',
									() => html`
										<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
															  .hideDisabledValues=${this.hideDisabledValues}
															  .excludedValues=${this.excludedValues}></spc-choice-attribute>`
								],
								['simpleSelect',
									() => html`
										<spc-choice-attribute-select instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
															  .hideDisabledValues=${this.hideDisabledValues}
															  .excludedValues=${this.excludedValues}></spc-choice-attribute-select>`
								],
								() => html`
									<spc-choice-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
														  .hideDisabledValues=${this.hideDisabledValues} .excludedValues=${this.excludedValues}></spc-choice-attribute>`
							])}`
					],
					['_Component', () =>
						html`
							<spc-component-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
													 .hideDisabledValues=${this.hideDisabledValues}></spc-component-attribute>`
					],
					['Boolean', () =>
						html`
							<spc-boolean-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
												   .hideDisabledValues=${this.hideDisabledValues}></spc-boolean-attribute>`
					],
					['Numeric', () =>
						html`
							<spc-numeric-attribute instance="${this.instance}" .displayStyle=${this.displayStyle} .attribute=${this.attribute}
												   .hideDisabledValues=${this.hideDisabledValues}></spc-numeric-attribute>`
					],
					() => html`<span>Unknown Type ${this.type} (${this.attribute.key})</span>`
				]
			)}
			${when(this.addon !== null, () => this.addon)}
		`;
	}
}
